<template>
  <div class="myseed-certificate">
    <multiform />
  </div>
</template>

<script>
import multiform from './components/multiform.vue';

export default {
  name: 'VueMyseedCertificate',
  components: {
    multiform,
  },
};
</script>

<style lang="css" scoped></style>
